import { TextField, styled } from '@mui/material';

export const CustomTextField = styled(TextField, {
  shouldForwardProp: (props) => props !== 'focusColor',
})((p) => {
  // default when focusColor is empty
  const focusColor = p.focusColor || p.theme.palette.secondary.main;
  const white = p.theme.palette.whiteText.main;

  return {
    // input label when focused
    '& label.Mui-focused': {
      color: focusColor,
    },

    '& .MuiInputLabel-root': {
      color: white,
    },

    '& .MuiFormHelperText-root': {
      color: focusColor,
      '&.Mui-error': {
        color: focusColor,
      },
    },

    // focused color for input with variant='standard'
    '& .MuiInput-underline:after': {
      borderBottomColor: focusColor,
    },
    // focused color for input with variant='filled'
    '& .MuiFilledInput-underline:after': {
      borderBottomColor: focusColor,
    },

    // focused color for input with variant='outlined'
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: white,
      },
      '&.Mui-focused fieldset': {
        borderColor: focusColor,
      },
      '&:hover fieldset': {
        borderColor: focusColor,
      },
    },

    '& .MuiInput-root': {
      '&:before': {
        borderBottomColor: focusColor,
      },
      '&:hover:before': {
        borderColor: focusColor,
      },
    },
  };
});